import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import PerText from '../Text'
import { EmployeeDisplayTinyInfo, Scalars } from '../../../types'
import { OptionProps } from 'antd/lib/select'
import { employeeDisplayTinyInfoSorter } from '../../../shared/sortUtils'
import { useAuth } from '../../../context/auth-context'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'
const { Option } = Select

interface Props {
  employeeList: EmployeeDisplayTinyInfo[]
  employee: EmployeeDisplayTinyInfo
  onChangeEmployee: (employee: EmployeeDisplayTinyInfo) => void
}

export const EmployeeSelect: FC<Props> = ({ employeeList, employee, onChangeEmployee }) => {
  const [t] = useTranslation()
  const { user } = useAuth()

  return (
    <div data-testid="invite-modal-employee-select">
      <>
        {employeeList && employeeList.length > 1 && (
          <Select
            showSearch
            style={{ width: '100%' }}
            onChange={(value: Scalars['HashedId']) => {
              const empl = employeeList.find((e) => e.id === value)
              if (empl) onChangeEmployee(empl)
            }}
            value={employee.id}
            defaultValue={employee.id}
            filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
              return option && option.props && option.props.children
                ? option.props.children.toString().toLowerCase().includes(input.trim().toLowerCase())
                : false
            }}
            notFoundContent={t('meetingInvite.notFoundEmployee')}
            data-e2e-invite-modal-employee-select
          >
            {[...employeeList]
              .sort((employeeA, employeeB) => employeeDisplayTinyInfoSorter(user.nameDisplayPreference, employeeA, employeeB))
              .map((employee) => (
                <Option
                  key={employee.id}
                  value={employee.id}
                  data-e2e-invite-modal-employee-select-option={computeFullname(
                    user.nameDisplayPreference,
                    employee.firstName,
                    employee.lastName,
                  )}
                >
                  {computeFullname(user.nameDisplayPreference, employee.firstName, employee.lastName)}
                </Option>
              ))}
          </Select>
        )}
        {employeeList && employeeList.length === 1 && (
          <PerText>{computeFullname(user.nameDisplayPreference, employeeList[0].firstName, employeeList[0].lastName)}</PerText>
        )}
      </>
    </div>
  )
}
